/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Component } from 'react';
import axios from 'axios';
import Button from '../../ui/Button';
import colors from '../../../css/colors';
import getBase64 from '../../FileUploads';
import { showNextButton, getNextLink } from '../FormStepperFunctions';
import withProperty from '../WithProperty';
import { selectStyles } from '../SharedFormStyles';
import { Multiselect } from 'react-widgets';
import { Checkbox, Loader } from 'semantic-ui-react';
import WithDocumentStation from '../ui/DocumentStation/WithDocumentStation';
import ReusableTopOfForm from '../ReusableTopOfForm';
import { InfoFoundSection } from '../nameSearches/Components/InfoFoundSection';
import qs from 'qs';
import NameSearchUploadAttachments from '../NameSearchUploadAttachments/NameSearchUploadAttachments';
import { RadioButton } from '../ui/BinaryRadioButton';

const searchTypeId = 90;

class NysTaxWarrantSearch extends Component {
  state = {
    nameOptions: [],
    names: [],
    attachedFiles: [],
    townFee: null,
    additionalInfo: '',
    loaderStatus: false,
    doNotCheck: false,
    searchId: 0,
    isContin: false,
    documentKey: 0,
  };

  componentDidMount = async () => {
    axios
      .get(`/api/searches/GetSearchByType/${searchTypeId}/${+this.props.match.params.propertyid}`)
      .then(({ data }) => {
        this.props.setSearchId(data.id);
        this.setState({ searchId: data.id });
      });
    const queryString = qs.stringify({ searchType: 'State Tax Warrant Search' });
    const { data: nameOptions } = await axios.get(
      `/api/property/GetPropertyContacts/${+this.props.match.params.propertyid}?${queryString}`
    );

    axios
      .get(`/api/searches/checkIfContin/${+this.props.match.params.propertyid}/${searchTypeId}`)
      .then(({ data: { isContin } }) => {
        this.setState({ isContin });
      });

    const { data: savedData } = await axios.get(
      `/api/searches/getSaved?propertyId=${+this.props.match.params.propertyid}&searchTypeId=${searchTypeId}`
    );

    this.setState({ ...savedData, nameOptions: nameOptions.map(n => ({ ...n, infoFound: false, childSupportInfoFound: false })) });
  };

  onFilesAdded = files => {
    this.setState({ attachedFiles: [...this.state.attachedFiles, ...files] });
  };

  onFileRemoved = file => {
    this.setState({
      attachedFiles: this.state.attachedFiles.filter(f => f !== file),
    });
  };

  handlePreview = async () => {
    const { data: html } = await axios.post('/api/searches/CreatePDF', {
      template: 'namesearchtemplate',
      data: await this.getFormContent(),
    });
    this.setState({ pdfHtml: html });
  };

  handleDownload = async () => {
    this.setState({ loaderStatus: true });
    
    await axios.post('/api/searches/DownloadPDF', {
      template: 'namesearchtemplate',
      data: await this.getFormContent()
    });
    const nextLink = getNextLink(
      this.props.property.orderId,
      searchTypeId,
      this.props.match.params.propertyid
    );
    this.props.history.push(nextLink);

    this.setState({ loaderStatus: false });
  };

  handleCreate(name) {
    const { nameOptions, names } = this.state;

    const newOption = {
      name,
      id: nameOptions.length + 1,
      infoFound: false,
      childSupportInfoFound: false,
    };

    this.setState({
      names: [...names, newOption],
      nameOptions: [...nameOptions, newOption],
    });
  }

  getFormContent = async () => {
    const { additionalInfo, attachedFiles, names, doNotCheck, isContin } = this.state;

    const promises = attachedFiles.map(async f => {
      const base64 = await getBase64(f);
      return { name: f.name, base64String: base64 };
    });
    const files = await Promise.all(promises);
    return {
      date: new Date(),
      searchType: 'NYS Tax Warrant Search',
      noText: 'Nothing Found',
      yesText: 'Please see these findings (Attached):',
      doNotCheck,
      description: '',
      propertyId: +this.props.match.params.propertyid,
      searchTypeId,
      names,
      violationCheckTitle: 'A Search of the New York State Tax Warrants database returns the following:',
      childSupportViolationCheckTitle: 'A Search of the Child Support Warrants database returns the following:',
      additionalInfo,
      searchDocumentType: 'NYS Tax Warrant Attachment',
      attachments: files,
      state: this.props.property?.state,
      additionalInfo,
      attachments: attachedFiles,
      isContin,
    };
  };

  render() {
    const { names, nameOptions, additionalInfo, pdfHtml, loaderStatus, doNotCheck } = this.state;
    const showNext = showNextButton(this.props.property.orderId, searchTypeId);
    const params = new URLSearchParams(this.props.location.search);
    const isEdit = params.get('isEdit');
    return (
      <div css={{ display: 'flex', height: '100%' }}>
        <div css={{ width: 654 }}>
          <ReusableTopOfForm
            handlePreview={this.handlePreview}
            searchHeader="NYS Tax Warrant Search"
            propertyId={this.props.match.params.propertyid}
            searchTypeId={searchTypeId}
            property={this.props.property}
            getFormContent={this.getFormContent}
            template="namesearchtemplate"
            searchId={this.state.searchId}
          />
          {this.state.loadingNames ? (
            <div>
              <Loader active inline size="small" />
            </div>
          ) : (
            <RadioButton
              checked={this.state.selectAllNames}
              text="Select All Names"
              addedStyles={{ marginBottom: 10 }}
              onChange={() => {
                const stateValue = !this.state.selectAllNames;
                if (stateValue) {
                  this.setState({ names: nameOptions });
                }
                this.setState({ selectAllNames: stateValue });
              }}
            />
          )}
          <div css={{ marginBottom: 32 }}>
            <span
              css={{
                marginBottom: 8,
                fontWeight: 'bold',
                display: 'inline-block',
              }}
            >
              Names
            </span>
            <div css={selectStyles}>
              <Multiselect
                value={names}
                data={nameOptions}
                onChange={editedNames => this.setState({ names: editedNames })}
                onCreate={name => this.handleCreate(name)}
                allowCreate="onFilter"
                valueField="id"
                textField="name"
              />
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
            <Checkbox
              checked={doNotCheck}
              label={'Do not check'}
              onChange={() => this.setState({ doNotCheck: !doNotCheck })}
            />
            {this.state.names.length > 0 && (
              <NameSearchUploadAttachments
                names={this.state.names}
                afterSubmit={newNames => {
                  this.setState({
                    names: newNames,
                    documentKey: this.state.documentKey + 1,
                  });
                }}
                searchId={this.state.searchId}
                searchTypeId={searchTypeId}
              />
            )}
          </div>
          {!doNotCheck && names?.length > 0 && (
            <InfoFoundSection
              headerText={'Tax Warrant Information Found:'}
              names={names}
              onAllYesCheck={() => this.setState({ names: names.map(n => ({ ...n, infoFound: true })) })}
              onAllNoCheck={() => this.setState({ names: names.map(n => ({ ...n, infoFound: false })) })}
              onChangeYes={n =>
                this.setState({
                  names: names.map(d => (d.id === n.id ? { ...d, infoFound: true } : d)),
                })
              }
              onChangeNo={n =>
                this.setState({
                  names: names.map(d => (d.id === n.id ? { ...d, infoFound: false } : d)),
                })
              }
            />
          )}
          {!doNotCheck && names?.length > 0 && (
            <InfoFoundSection
              headerText={'Child Support Warrant Information Found:'}
              foundKey="childSupportInfoFound"
              names={names}
              onAllYesCheck={() => this.setState({ names: names.map(n => ({ ...n, childSupportInfoFound: true })) })}
              onAllNoCheck={() => this.setState({ names: names.map(n => ({ ...n, childSupportInfoFound: false })) })}
              onChangeYes={n =>
                this.setState({
                  names: names.map(d => (d.id === n.id ? { ...d, childSupportInfoFound: true } : d)),
                })
              }
              onChangeNo={n =>
                this.setState({
                  names: names.map(d => (d.id === n.id ? { ...d, childSupportInfoFound: false } : d)),
                })
              }
            />
          )}

          <div css={{ margin: '32px 0' }}>
            <textarea
              css={{
                resize: 'none',
                backgroundColor: colors.greyOrder,
                borderRadius: 3,
                width: 654,
                height: 192,
                marginBottom: 24,
                ':focus': { outline: 0 },
              }}
              value={additionalInfo}
              onChange={evt => this.setState({ additionalInfo: evt.target.value })}
              placeholder="Additional Information"
            />
          </div>
          {this.state.searchId > 0 && (
            <WithDocumentStation
              searchId={this.state.searchId}
              searchTypeId={searchTypeId}
              names={nameOptions}
              key={this.state.documentKey}
            />
          )}
          <div css={{ marginTop: 43, display: 'flex', justifyContent: 'flex-end' }}>
            <div css={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                secondary
                onClick={() =>
                  this.props.history.push(`/orders/order-information/${this.props.property.orderId}`)
                }
                disabled={loaderStatus}
              >
                Cancel
              </Button>
              <div css={{ marginLeft: 8 }}>
                <Button onClick={this.handleDownload} loadingStatus={loaderStatus}>
                  {showNext ? 'Next' : `${isEdit ? 'Save' : 'Submit'}`}
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div css={{ width: '100%' }}>
          <iframe style={{ width: '100%', height: '100%' }} srcDoc={pdfHtml} />
        </div>
      </div>
    );
  }
}
export default withProperty(NysTaxWarrantSearch, searchTypeId);
